"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.errors = void 0;
exports.newSessionExpireError = newSessionExpireError;
exports.newForbiddenError = newForbiddenError;
exports.newServerError = newServerError;
exports.newGeneralError = newGeneralError;
exports.newBadRequestError = newBadRequestError;
exports.requestWrapper = requestWrapper;
exports.makeGetRequest = makeGetRequest;
exports.makePostRequest = makePostRequest;
exports.makePatchRequest = makePatchRequest;
exports.makeDeleteRequest = makeDeleteRequest;
const errorCodes_1 = __importDefault(require("./enum/errorCodes"));
const apiError_1 = require("./model/apiError");
exports.errors = {
    BAD_REQUEST: new apiError_1.ApiError(errorCodes_1.default.BAD_REQUEST),
    SESSION_EXPIRED: new apiError_1.ApiError(errorCodes_1.default.SESSION_EXPIRED),
    FORBIDDEN: new apiError_1.ApiError(errorCodes_1.default.FORBIDDEN),
    SERVER_ERROR: new apiError_1.ApiError(errorCodes_1.default.SERVER_ERROR),
    GENERAL: new apiError_1.ApiError(errorCodes_1.default.GENERAL),
};
function newSessionExpireError(statusCode) {
    return new apiError_1.ApiError(errorCodes_1.default.SESSION_EXPIRED, { statusCode });
}
function newForbiddenError(statusCode) {
    return new apiError_1.ApiError(errorCodes_1.default.FORBIDDEN, { statusCode });
}
function newServerError(statusCode) {
    return new apiError_1.ApiError(errorCodes_1.default.SERVER_ERROR, { statusCode });
}
function newGeneralError(statusCode) {
    return new apiError_1.ApiError(errorCodes_1.default.GENERAL, { statusCode });
}
function newBadRequestError(statusCode, detail) {
    return new apiError_1.ApiError(errorCodes_1.default.BAD_REQUEST, { statusCode, detail });
}
const domain = "/api/v2/";
const postHeaders = {
    "Content-Type": "application/json",
};
const patchHeaders = postHeaders;
async function requestWrapper(f) {
    try {
        const res = await f();
        switch (res.status) {
            case 200: // A 200 is success. Break and return response.
                break;
            case 400: // Bad request or client version deprecation.
                throw newBadRequestError(res.status, await res.text());
            case 401: // 401 means your session has expired and must login. Error.
                throw newSessionExpireError(res.status);
            case 403: // Forbidden
                throw newForbiddenError(res.status);
            case 500: // Internal server error
                throw newServerError(res.status);
            default: // Any other status. Error.
                throw newGeneralError(res.status);
        }
        return res;
    }
    catch (err) {
        throw err;
    }
}
async function makeGetRequest(route) {
    return await requestWrapper(async () => await fetch(`${domain}${route}`, {
        method: "GET",
    }));
}
async function makePostRequest(route, body) {
    return await requestWrapper(async () => await fetch(`${domain}${route}`, {
        method: "POST",
        body,
        headers: postHeaders,
    }));
}
async function makePatchRequest(route, body) {
    return await requestWrapper(async () => await fetch(`${domain}${route}`, {
        method: "PATCH",
        body,
        headers: patchHeaders,
    }));
}
async function makeDeleteRequest(route) {
    return await requestWrapper(async () => await fetch(`${domain}${route}`, {
        method: "DELETE",
    }));
}
